"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayStatus = exports.DownloadManagerState = exports.DownloadManagerService = exports.DownloadManager = void 0;
exports.getDownloadManager = getDownloadManager;
const download_manager_1 = require("./download.manager");
var download_manager_2 = require("./download.manager");
Object.defineProperty(exports, "DownloadManager", { enumerable: true, get: function () { return download_manager_2.DownloadManager; } });
var download_manager_service_1 = require("./download.manager.service");
Object.defineProperty(exports, "DownloadManagerService", { enumerable: true, get: function () { return download_manager_service_1.DownloadManagerService; } });
var download_manager_state_1 = require("./download.manager.state");
Object.defineProperty(exports, "DownloadManagerState", { enumerable: true, get: function () { return download_manager_state_1.DownloadManagerState; } });
Object.defineProperty(exports, "getDisplayStatus", { enumerable: true, get: function () { return download_manager_state_1.getDisplayStatus; } });
/**
 * Lazy singleton to avoid circular dependency with Services.
 * DownloadManager imports Services, so it cannot be instantiated
 * inside the ServiceRegistry constructor.
 */
let _instance = null;
function getDownloadManager() {
    if (_instance == null) {
        _instance = new download_manager_1.DownloadManager();
    }
    return _instance;
}
//# sourceMappingURL=index.js.map